import './Navi.scss';
function Mainbg() {
   return(
      <div className="mainbg"> </div>
   )
}
export default Mainbg;